import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Music2, Mic, Headphones, Radio } from 'lucide-react';
import InlineMusicPlayer from '../components/InlineMusicPlayer';

const Music = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #ba55d3, #ff00ff)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Music Creation Studio
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            AI-powered music composition, audio production, and creative sound design
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(186, 85, 211, 0.1)',
            border: '1px solid rgba(186, 85, 211, 0.3)'
          }}>
            <Music2 size={32} style={{ color: '#ba55d3', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Composition</h3>
            <p style={{ color: '#888' }}>Create melodies, harmonies, and arrangements</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(255, 0, 255, 0.1)',
            border: '1px solid rgba(255, 0, 255, 0.3)'
          }}>
            <Mic size={32} style={{ color: '#ff00ff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Recording</h3>
            <p style={{ color: '#888' }}>Multi-track recording and vocal production</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(138, 43, 226, 0.1)',
            border: '1px solid rgba(138, 43, 226, 0.3)'
          }}>
            <Headphones size={32} style={{ color: '#8a2be2', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Mixing & Mastering</h3>
            <p style={{ color: '#888' }}>Professional audio mixing and mastering</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(186, 85, 211, 0.3)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#ba55d3', marginBottom: '1.5rem' }}>Music Creation Tools</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Professional music production widgets:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>AI Music Composer & Generator</li>
              <li>Virtual Instruments (Piano, Drums, Guitar, Bass)</li>
              <li>Audio Recorder & Editor</li>
              <li>Mixing Console & Effects Rack</li>
              <li>Mastering Suite</li>
              <li>Chord Progression Generator</li>
              <li>Lyrics Assistant</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(186,85,211,0.1), rgba(255,0,255,0.1))',
          border: '2px solid #ba55d3'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <Radio size={32} style={{ color: '#ba55d3' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#ba55d3' }}>Music AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get creative music guidance from AI music producers and composers. Ask about music theory, 
            production techniques, composition, or any music-related question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #ba55d3, #ff00ff)',
            color: '#fff',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Music AI
          </Button>
        </Card>

        {/* Aria's Curated Signal — Feb 2026 rebuild
            Music / Podcast library + Federation Radio (Live365) + search. */}
        <div data-testid="music-page-inline-player" style={{ marginTop: '2rem' }}>
          <InlineMusicPlayer />
        </div>
      </div>
    </div>
  );
};

export default Music;